interface TokenMetadata {
  address: string;
  symbol: string;
  name: string;
  decimals: number;
  logoURI?: string;
}

export const TOKEN_LIST: TokenMetadata[] = [
  {
    address: '0x118917a40FAF1CD7a13dB0Ef56C86De7973Ac503',
    symbol: 'MUSD',
    name: 'MEZO USD',
    decimals: 18,
  },
  {
    address: '0x7B7c000000000000000000000000000000000001',
    symbol: 'MEZO',
    name: 'MEZO',
    decimals: 18,
  },
  {
    address: '0x7b7C000000000000000000000000000000000000',
    symbol: 'BTC',
    name: 'Bitcoin',
    decimals: 18,
  },
];
